import React from 'react';
import { getLabel } from '../data/labels';

export default function ListBetFilters(props) {
    const filter = props.filter;
    
    return (
        <div className="w-full font-medium text-xs">
            <div className="w-full flex items-center justify-evenly font-medium text-sm">
                <div className={"h-[24px] p-2 flex items-center border border-cs16 rounded-md" + (filter == null  ? ' bg-cs4 text-cs1' : '')} onClick={() => props.changeFilter(null)}>
                    {getLabel('general.tutti')}
                </div>
                <div className={"h-[24px] p-2 flex items-center border border-cs16 rounded-md" + (filter === 'home' ? ' bg-cs4 text-cs1' : '')} onClick={() => props.changeFilter('home')}>
                    {getLabel('h2h.home')}
                </div>
                <div className={"h-[24px] p-2 flex items-center border border-cs16 rounded-md" + (filter === 'away' ? ' bg-cs4 text-cs1' : '')} onClick={() => props.changeFilter('away')}>
                    {getLabel('h2h.away')}
                </div>
            </div>
        </div>
    );
}
